import React, { useState, memo, useCallback } from "react";
import "./reward.scss";
import Tabs from "react-bootstrap/Tabs";
import { Tab } from "react-bootstrap";
import CouponsList from "./couponsList";
import SharedCoupons from "./sharedCoupons";
import { useCoupons, useCareGroup } from "../../Hooks/useCoupons";
import DownloadReport from "../DownloadReport/DownloadReport";

const Reward = () => {
  const [key, setKey] = useState("Coupons");

  const { isFetching, error, data = [] } = useCoupons();
  const { data: careGroupData } = useCareGroup();

  return (
    <>
      <div className="reward-title">
        <h2>Patient Coupons</h2>
      </div>
      <div className="reward-tab-main">
        <Tabs
          activeKey={key}
          id="uncontrolled-tab-example"
          onSelect={(k) => setKey(k)}
        >
          <Tab eventKey="Coupons" title="Coupons">
            <CouponsList
              isFetching={isFetching}
              error={error}
              data={data}
              careGroupData={careGroupData}
            />
          </Tab>
          <Tab eventKey="SharedCoupons" title="Shared Coupons">
            <SharedCoupons isFetching={isFetching} error={error} data={data} />
          </Tab>
        </Tabs>
      </div>
      <DownloadReport/>
    </>
  );
};

export default memo(Reward);
